module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing_4_LV-4ed2c7ff5bcbea47ae6c6bfc622934be.svg";